import { render, staticRenderFns } from "./debtsPage.vue?vue&type=template&id=05e437b3&scoped=true&"
import script from "./debtsPage.vue?vue&type=script&lang=ts&"
export * from "./debtsPage.vue?vue&type=script&lang=ts&"
import style0 from "./debtsPage.vue?vue&type=style&index=0&id=05e437b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e437b3",
  null
  
)

export default component.exports